/**
 * 事件常量
 *
 * - 这里讲讲到底怎么编写事件常量：
 * 以组件名定义对象第一层的属性，比如组件VideoPlayerWrap => VIDEO_PLAYER
 *
 *
 * - 怎么定义事件？
 * 举个栗子，我点击了“继续学习”按钮让播放器播放了视频，我会有疑惑，这里事件是“点击按钮”还是“播放视频”？
 * 答案：事件是“点击按钮”。用”因为什么导致触发了什么“这个模版去套就可以了，前者是事件，后者是事件回调
 */
export default {
  NORMAL_COURSE: {
    UPDATE_GROUP_INFO: Symbol('updateGroupInfo'),
  },
  VIDEO_PLAYER: {
    START: Symbol('videoStart'), // 音视频开始播放
    FINISH: Symbol('videoFinish'), // 音视频学习完成
    END: Symbol('videoEnd'), // 音视频播放结束
    // MEDIUM_CHANGE: 'mediumChange' // 音视频更改
    CANCEL_FIXED: Symbol('cancel_fixed'),
    CONTINUOUS_PLAY: Symbol('continuousPlay'),
  },
  CATALOG_WRAP: {
    COURSE_CHANGE: Symbol('courseChange'), // 课程更改
  },
  FOOTER_WRAP: {
    CONTINUE_STUDY: Symbol('continueStudy'), // 继续学习
    LOCATE_CATALOG: Symbol('locateCatalog'), // 定位目录
  },
  COURSE: {
    // 课程课组整体(无论任何模式)
    REPLAY_FULL_AUTION: Symbol('fullAutionEnd'), // 再次试听“全试听课”,
    CATALOG_AND_VIDEO_CHANGE: Symbol('triggleCatalogChange'),
    SHOW_QRCODE: Symbol('showQrcode'),
    COURSEWARE_UPDATE_TRIGGER: Symbol('couresewareUpdateTrigger'), // 触发更换作业提醒
    TO_COURSEWARE_UPDATE: Symbol('toCoursewareUpdate'), // 跳转到更换作业页面
  },
  COMMENT_WRAP: {
    SEND_COMMENT: Symbol('sendComment'),
    DELETE_COMMENT_SUCCESSFULLY: Symbol('deleteCommentSuccessfully'),
    ADD_COMMENT_SUCCESSFULLY: Symbol('addCommentSuccessfully'),
    HIDE_FOOTER: Symbol('hideFooter'),
  },
  GUIDE: {
    GUIDE_INIT: Symbol('guide_init'),
    GUIDE_START: Symbol('guide_start'),
    NEXT_STEP: Symbol('next_step'),
    GUIDE_END: Symbol('guide_end'),
  },
  API_PROTECT: {
    // api 接口保护
    INTERCEPT: Symbol('apiProtectIntercept'), // 接口响应保护拦截
    REMOVE: Symbol('apiProtectInterceptRemove'), // 拦截解除
  },
};
